// hooks/useIsCollapsed.tsx
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'collapsed-sidebar';

export default function useIsCollapsed(): [boolean, React.Dispatch<React.SetStateAction<boolean>>] {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  // On mount, read the value from localStorage
  useEffect(() => {
    const storedValue = localStorage.getItem(STORAGE_KEY);
    if (storedValue !== null) {
      setIsCollapsed(JSON.parse(storedValue));
    }
  }, []);

  // Whenever isCollapsed changes, update localStorage
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  return [isCollapsed, setIsCollapsed];
}
